import { Button } from '../ui/Button';

interface OnboardingNavButtonsProps {
  currentStep: number;
  totalSteps: number;
  isOAuthUser: boolean;
  isLoading: boolean;
  onBack: () => void;
  onSkip: () => void;
  onNext: () => void;
  onSubmit: () => void;
}

/**
 * Back / Skip / Next / Complete row at the foot of the onboarding card.
 * Purely presentational — the step machine lives in the Onboarding page.
 */
export const OnboardingNavButtons = ({
  currentStep,
  totalSteps,
  isOAuthUser,
  isLoading,
  onBack,
  onSkip,
  onNext,
  onSubmit,
}: OnboardingNavButtonsProps) => (
  <div className="flex gap-4">
    {currentStep > 1 && (
      <Button variant="outline" size="lg" onClick={onBack} disabled={isLoading}>
        Back
      </Button>
    )}

    {currentStep === 2 && (
      <Button variant="outline" size="lg" onClick={onSkip} disabled={isLoading}>
        Skip
      </Button>
    )}

    {currentStep === 3 && !isOAuthUser && (
      <Button variant="outline" size="lg" onClick={onSkip} disabled={isLoading}>
        Skip
      </Button>
    )}

    {currentStep < totalSteps ? (
      <Button
        variant="primary"
        size="lg"
        onClick={onNext}
        disabled={isLoading}
        fullWidth={currentStep === 1}
      >
        Next
      </Button>
    ) : (
      <Button
        variant="primary"
        size="lg"
        onClick={onSubmit}
        loading={isLoading}
        disabled={isLoading}
        fullWidth
      >
        Complete Profile
      </Button>
    )}
  </div>
);
